const escapeHtml = (value) => String(value ?? '')
  .replaceAll('&', '&amp;')
  .replaceAll('<', '&lt;')
  .replaceAll('>', '&gt;')
  .replaceAll('"', '&quot;')
  .replaceAll("'", '&#39;');

const exportTablePdf = async (title, fileName, columns, rows) => {
  const printableWindow = window.open('', '_blank', 'noopener,noreferrer');
  if (!printableWindow) {
    throw new Error('Unable to open print window');
  }

  const headerHtml = columns.map((column) => `<th>${escapeHtml(column)}</th>`).join('');
  const bodyHtml = rows
    .map((row) => {
      const cells = columns.map((column) => `<td>${escapeHtml(row?.[column] ?? '')}</td>`).join('');
      return `<tr>${cells}</tr>`;
    })
    .join('');

  printableWindow.document.write(`
    <html>
      <head>
        <title>${escapeHtml(fileName || 'report.pdf')}</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 24px; }
          h1 { margin: 0 0 16px; font-size: 18px; }
          table { width: 100%; border-collapse: collapse; font-size: 12px; }
          th, td { border: 1px solid #d0d7de; padding: 6px 8px; text-align: left; }
          th { background: #f6f8fa; }
        </style>
      </head>
      <body>
        <h1>${escapeHtml(title)}</h1>
        <table>
          <thead><tr>${headerHtml}</tr></thead>
          <tbody>${bodyHtml}</tbody>
        </table>
      </body>
    </html>
  `);
  printableWindow.document.close();
  printableWindow.focus();
  printableWindow.print();
};

export default exportTablePdf;
